export default __webpack_public_path__ + "static/media/404.eb0b43e4.png";